// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderBreadcrumbs_container__VxBSB"};